import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Button, Collapse, List, Select, Space } from 'antd';
import _ from 'lodash';

import { ApartmentOutlined, CloseOutlined, TagsOutlined, TagOutlined, UserOutlined } from '@/icons';

import styles from './SelectedPanel.module.less';

const TYPES = {
    departs: '部门',
    users: '员工',
    tags: '企微标签',
    // apptags: 'AD 应用标签',
    // adtags: 'AD 标签',
};

export default function SelectedPanel({
    selectedValues = {},
    onDeleteSelected,
    requireUserBu = false,
    buOptions = [],
    onUpdateSelected,
}) {
    function onDeleteClick(type, id) {
        return () => {
            onDeleteSelected(type, id);
        };
    }

    function renderIcon(type) {
        if (type === 'departs') {
            return <ApartmentOutlined />;
        }
        if (type === 'users') {
            return <UserOutlined />;
        }
        if (type === 'tags') {
            return <TagsOutlined />;
        }
        if (['apptags', 'adtags'].includes(type)) {
            return <TagOutlined />;
        }
        return null;
    }

    function renderItem(type) {
        // eslint-disable-next-line react/display-name
        return item => {
            const { id, name, buId } = item;

            const actions = [
                <Button
                    key="delete"
                    type="text"
                    className={styles.closeBtn}
                    icon={<CloseOutlined className={styles.closeIcon} />}
                    onClick={onDeleteClick(type, id)}
                />,
            ];

            return (
                <List.Item actions={actions} className={styles.item}>
                    <Space className={styles.itemInner}>
                        <Avatar icon={renderIcon(type)} size={24} />
                        <span className={styles.itemName}>{name}</span>
                        {requireUserBu && type === 'users' && (
                            <Select
                                className={styles.buSelect}
                                placeholder="请选择BU"
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                options={buOptions}
                                value={buId}
                                onChange={value => onUpdateSelected(type, id, { buId: value })}
                            />
                        )}
                    </Space>
                </List.Item>
            );
        };
    }

    function renderValues(type, values) {
        if (_.isEmpty(values)) {
            return null;
        }

        return (
            <Collapse.Panel key={type} header={`已选${TYPES[type]}`}>
                <List size="small" dataSource={values} renderItem={renderItem(type)} />
            </Collapse.Panel>
        );
    }

    const types = Object.keys(TYPES);

    return (
        <Collapse ghost defaultActiveKey={types}>
            {types.map(type => {
                const values = _.get(selectedValues, type);
                return renderValues(type, values);
            })}
        </Collapse>
    );
}

const valueType = PropTypes.arrayOf(
    PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        buId: PropTypes.string,
    })
);

SelectedPanel.propTypes = {
    selectedValues: PropTypes.shape({
        departs: valueType,
        users: valueType,
        tags: valueType,
    }),
    onDeleteSelected: PropTypes.func.isRequired,
    requireUserBu: PropTypes.bool,
    buOptions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string,
        })
    ),
    onUpdateSelected: PropTypes.func,
};
